var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-button',{directives:[{name:"loading",rawName:"v-loading",value:(_vm.loading),expression:"loading"}],attrs:{"type":_vm.type,"icon":_vm.icon},on:{"click":function($event){return _vm.submitAdd()}}},[_vm._t("default",[_vm._v("确 定")])],2)}
var staticRenderFns = []

export { render, staticRenderFns }